import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import loadLang from "../utils/loadLang";

Vue.use(Vuetify);


let lang = loadLang.getLang()

export default new Vuetify({
  rtl: lang === 'rtl',
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: 'white',
        secondary: '#bdbdae',
        third: '#585858',
        primaryLight: '#FFF8F6',
        secondaryLight: '#d1eeed'
      },
    },
    options: {
      customProperties: true
    }
  }
});

